import { useContext } from 'react';
import { EditorContext } from '@/features/editor/context/editor-context';
import { sanitizeKeyName } from '@/features/ai-agents/chat/editor-config';

export function useProxyActions() {
  const {
    devicePreview: { runInIframe },
  } = useContext(EditorContext);

  const runCleanup = () => {
    runInIframe((doc) => {
      try {
        doc?.[`currentWidget_cleanup`]?.();
      } catch (e) {
        console.error(`Error during cleanup:`, e);
      }
    });
  };

  const runState = (stateName: string) => {
    runInIframe((doc) => {
      try {
        doc?.[`currentWidget_state_${sanitizeKeyName(stateName)}`]?.();
      } catch (e) {
        console.error(`Error running state ${stateName}:`, e);
      }
    });
  };

  const runAction = (actionName: string) => {
    runInIframe((doc) => {
      try {
        doc?.[`currentWidget_action_${sanitizeKeyName(actionName)}`]?.();
      } catch (e) {
        console.error(`Error running action ${actionName}:`, e);
      }
    });
  };

  return {
    runCleanup,
    runState,
    runAction,
  };
}
